import * as React from 'react'
import { styled } from 'next-yak'
import * as S from '../../styles'

import * as colors from '../../constants/colors'
import * as glyphs from '../../icons/glyphs'

type SectionTitleProps = {
  children: React.ReactNode
  className?: string
  glyph?: React.ReactNode
  title?: React.ReactNode
}

function SectionWithTitleComponent({ className, title, children, glyph }: SectionTitleProps) {
  return (
    <div className={className}>
      <S.heading.XXS>
        {glyph} {title}
      </S.heading.XXS>
      {children}
    </div>
  )
}

export const SectionWithTitle = styled(SectionWithTitleComponent)`
  ${S.heading.XXS} {
    align-items: center;
    display: flex;
    margin-bottom: 7px;
    margin-right: 8px;

    ${glyphs.Icon} {
      color: ${colors.PRIMARY_GREY_500};
      margin-right: 10px;
    }
  }
`
